//#region imports
import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { AppConstants } from 'src/app/app.constants';
import { DetailsService } from 'src/app/services/details.service';
import { TranslateService } from '@ngx-translate/core';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SaveService } from 'src/app/services/save.service';
import { ContactDetails } from 'src/app/shared/model/save.model';
import { SectionService } from 'src/app/services/section.service';
//#endregion

@Component({
  selector: 'app-details-question10',
  templateUrl: './details-question10.component.html',
  styleUrls: ['./details-question10.component.css']
})
export class DetailsQuestion10Component implements OnInit {
  //#region variables
  filteredOptions: Observable<string[]>;
  choices = [];
  questions = [];
  code;
  location: any;
  locationValue: any;
  selectedCountry: any;
  contactDetails: ContactDetails;
  invalid = false;
  invalidLocation = false;
  //#endregion

  //#region methods
  constructor(
    private detailsService: DetailsService, private guaranteeService: GuaranteeService,
    private globals: Globals, private notification: NotificationService,
    private translate: TranslateService, private saveService: SaveService,
    private characteristicService: CharacteristicService, private sectionService: SectionService) {
    this.characteristicService.setShowPrevious(true);
  }

  postalForm = new FormGroup({
    cityName: new FormControl(null, [Validators.required]),
  });

  ngOnInit() {
    this.sectionService.setCurrentPage('P22-4');
    this.globals.trackPageActivity += ';' + 'P22-4';
    const sectionKey = AppConstants.SectionConstants.Section2Point2;
    this.contactDetails = this.saveService.getContactDetails();
    this.questions = this.detailsService.getDetailsQuestion(sectionKey, 'G15');
    const questionChoices = this.detailsService.getDetailsData(sectionKey, 'G15');
    this.setAnswers();
    for (const choice of questionChoices) {
      this.choices.push(choice);
    }
  }

  get cityName() {
    return this.postalForm.get('cityName');
  }

  setAnswers() {
    this.location = [];
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    this.globals.quesWarning = false;
    const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G15').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question').Answers;
    this.code = firstAnswer != null ? firstAnswer[0].AnswerText : '';
    this.globals.postalCode = this.code;
    this.globals.propertyPostCode = this.code;
    if (this.globals.languagecode === 'FR' && this.code !== 'undefined'
      && this.code != null && this.code !== '') {
      this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code).forEach(obj => this.location.push(obj.LibelleFR));
    } else if (this.globals.languagecode === 'NL' && this.code !== 'undefined'
      && this.code != null && this.code !== '') {
      this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code).forEach(obj => this.location.push(obj.LibelleNL));
    } else if (this.globals.languagecode === 'EN' && this.code !== 'undefined'
      && this.code != null && this.code !== '') {
      this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code).forEach(obj => this.location.push(obj.LibelleNL));
    }
    const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G15').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers;
    if (secondAnswer != null) {
      this.postalForm.patchValue({
        cityName: this.location.find(obj => obj === secondAnswer[0].AnswerText)
      });
      this.selectedCountry = this.location.find(obj => obj === secondAnswer[0].AnswerText);
    }
    this.globals.filteredLocality = this.cityName.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.globals.filteredLocation = this.location;
  }

  private _filter(value: string): string[] {
    const filterValue = value != null ? value.toLowerCase() : value;
    return this.location.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  validateInput(value) {
    const locationValue = value !== undefined ? this.globals.filteredLocation.find(obj => obj === value) : 1;
    if (locationValue == null) {
      this.postalForm.controls['cityName'].setErrors({ incorrect: true });
      this.invalidLocation = true;
      this.mapAnswer('Apartment_Property_Post_Code_Place_Question', null);
    }
  }

  modelChanged(choice, enteredValue) {
    this.guaranteeService.setInitialPricingData(null);
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.globals.filteredLocation = [];
    this.location = [];
    if (this.code.length === 4) {
      const location = this.globals.locationData.Locations.filter(obj => obj.PostalCode === this.code);
      this.invalid = location.length > 0 ? false : true;
      if (this.globals.languagecode === 'FR' && this.code != null && this.code !== '' && this.code.length === 4 && location != null) {
        location.forEach(obj => this.location.push(obj.LibelleFR));
      } else if (this.globals.languagecode === 'NL' && this.code != null && this.code !== '' &&
        this.code.length === 4 && location != null) {
        location.forEach(obj => this.location.push(obj.LibelleNL));
      }else{
        location.forEach(obj => this.location.push(obj.LibelleNL));
      }
      this.globals.filteredLocation = this.location;
      this.selectedCountry = this.location[0];
      this.invalidLocation = false;
      this.globals.filteredLocality = this.cityName.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );
      this.mapAnswer(choice, enteredValue);
    } else {
      this.invalid = false;
      this.selectedCountry = null;
      this.mapAnswer(choice, enteredValue);
    }
  }

  onSelectionChange(choice, event) {
    this.invalidLocation = false;
    this.globals.filteredLocality = this.cityName.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.mapAnswer('Apartment_Property_Post_Code_Place_Question', event);
  }

  mapAnswer(selectedChoice, selectedText) {
    this.globals.postalCode = this.code;
    this.globals.propertyPostCode = this.code;
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    let AnswerObject = {};
    let selectedQuestion: any;
    const today = new Date();
    switch (selectedChoice) {
      case 'Apartment_Property_Post_Code_Question':
        if (this.code.length === 4) {
          this.guaranteeService.setPostalCode(selectedText);
          selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question');
          AnswerObject = !!selectedText ? {
            ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
            AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
          } : null;
          // if (this.contactDetails !== undefined && this.contactDetails !== null) {
          //   this.contactDetails.PostalCode = selectedText;
          //   this.saveService.setContactDetails(this.contactDetails);
          // } else {
          //   this.contactDetails = {
          //     FirstName: null, LastName: null, Name: null, EmailAddress: null, Telephone: null,
          //     DateofBirth: null, PostalCode: selectedText
          //   };
          //   this.saveService.setContactDetails(this.contactDetails);
          // }
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
            QuestionGroup.find(obj => obj.GroupKey === 'G15').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question').Answers =
            AnswerObject != null ? [AnswerObject] : null;
          if (!!this.selectedCountry) {
            selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question');
            AnswerObject = !!this.code ? {
              ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: this.selectedCountry,
              AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
            } : null;
            data.Sections.find(obj => obj.SectionKey === 'S2.2').
              QuestionGroup.find(obj => obj.GroupKey === 'G15').
              Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers =
              AnswerObject != null ? [AnswerObject] : null;
          }
        } else {
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
            QuestionGroup.find(obj => obj.GroupKey === 'G15').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question').Answers = null;
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
            QuestionGroup.find(obj => obj.GroupKey === 'G15').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers = null;
        }
        break;
      case 'Apartment_Property_Post_Code_Place_Question':

        if (!this.invalidLocation) {
          selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question');
          AnswerObject = !!this.code ? {
            ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText.value,
            AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
          } : null;
          data.Sections.find(obj => obj.SectionKey === 'S2.2').QuestionGroup.find(obj => obj.GroupKey === 'G15').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers =
            AnswerObject != null ? [AnswerObject] : null;
        } else {
          data.Sections.find(obj => obj.SectionKey === 'S2.2').QuestionGroup.find(obj => obj.GroupKey === 'G15').
            Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers = null;
        }
        break;
    }
    sessionStorage.setItem('jsonData', JSON.stringify(data));
  }

  isNumber(evt, code) {
    this.detailsService.setDetailsProgressBarDetails();
    // if(this.globals.isMobile)
    // {this.detailsService.setmobileDetailsProgressBarDetails();}
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((code.length > 3) || (charCode > 31 && (charCode < 48 || charCode > 57))) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
